import "core-js/modules/es6.object.freeze";
import { cornerRadii, cornerRadiiRefresh } from './../corner-radii';
export var badge = Object.freeze({
  cornerRadii: cornerRadii["default"]
});
export var badgeRefresh = Object.freeze({
  cornerRadii: cornerRadiiRefresh.circle
});